<template>
	<div class="page page-purchaseEdit">
		<div class="pageTitleBox">
			<div class="boxNameL">
				申请人{{this.$store.state.userInfo.uName}}
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div>
		</div>
		<div class="goodscon">

			<div v-for="(item,index) in sumData" :key='index'>
				<div class="comH2" @click="handleShopClick(item.goodsType)">
					<div>{{item.goodsType==1?'医疗类':(item.goodsType==0)?'商品类':'耗材类'}}</div>
					<i v-if="showType['showType'+item.goodsType]" class="el-icon-caret-bottom"></i>
					<i v-else class="el-icon-caret-top"></i>
				</div>

				<el-table v-show="showType['showType'+item.goodsType]" show-summary :data="item.goods" style="width: 100%;" size="small">
					<el-table-column label="商品名称">
						<template slot-scope="scope">
							<span>{{scope.row.title}}</span>
						</template>
					</el-table-column>
					<el-table-column label="品牌" width="120px">
						<template slot-scope="scope">
							<span>{{scope.row.brand}}</span>
						</template>
					</el-table-column>
					<el-table-column label="规格">
						<template slot-scope="scope">
							<span>{{scope.row.skuValue}}</span>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="120px">
						<template slot-scope="scope">
							<span>{{scope.row.unit}}</span>
						</template>
					</el-table-column>
					<el-table-column label="采购数量" prop="count" width="180px">
						<template slot-scope="scope">
							<div>
							<el-input-number size="small" v-model="scope.row.count" :min="1" label="描述文字"></el-input-number>
					   </div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="180px">
						<template slot-scope="scope">
							<el-input style="width: 150px;" size="small" v-model="scope.row.procureGoodsRemark" placeholder="请输入备注"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px">
						<template slot-scope="scope">
							<el-button icon="el-icon-delete" type="text" @click='deletGoods(scope.row,scope.$index)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-form :model="editparams" style="margin-top: 20px;">
				<el-form-item label="采购备注" label-width="80px">
					<el-input style="width: 300px;" type="textarea" :rows="3" placeholder="请输入内容" v-model="editparams.remarks">
					</el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="footer">
			<div>
				<span class="desc">合计产品数量
					<span style="color: #FF4D51;">{{editparams.procureGoodsList.length}}</span>
				</span>
				<span class="desc">总计采购数量
					<span style="color: #FF4D51;">{{goodsToatalCount}}</span>
				</span>
			</div>
			<div>
				<span class="desc">
					期望到货日期
					<el-date-picker :picker-options="pickerOptions" value-format='yyyy-MM-dd' v-model="expectTime" type="date"
					placeholder="选择日期">
					</el-date-picker>
				</span>
				<el-button class="desc" type="warning" @click='addGoods'>添加商品</el-button>
				<el-button class="desc" type="warning" @click='submit(false)'>保存</el-button>
				<el-button class="desc" type="warning" @click='submit(true)'>提交审批</el-button>
			</div>
		</div>
		
		<!-- <div v-if="dialogAddShop_state">
			<dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
		</div> -->
		<template v-if="dialogState">
			<dialogAddShop @closeOn="dialogState = false" :addShopState.sync="dialogState" @submit="selectGoods" :tree.sync="tree"></dialogAddShop>
			<!-- <dialogAddGoods labelType="所有商品" dialogType="1" @select="selectGoods" @close="dialogState=false"></dialogAddGoods> -->
		</template>
	</div>
</template>

<script>
	import dialogAddShop from "../../../components/dialog_addShopCG.vue"
	
	import {
		setProcureRequest,
		procureRequestDl,

	} from "@/api/shopPurchaseApiNew.js"
	export default {
		components: {
			dialogAddShop
		},

		data() {
			return {
				tree:[{
					id:"602f1e89c904d9db7ccf3c03"
				},{
					id:"602f1e88c904d9db7ccf3bec"
				},{
					id:"6049cf035a0dfcc381f9311a"
				}],
				pickerOptions: {
					disabledDate(time) {
						//如果没有后面的-8.64e7就是不可以选择今天的 
						return time.getTime() < Date.now() - 8.64e7;
					}
				},
				dialogState: false,
				expectTime: '',
				isSub: true,
				editparams: {
					procureRequestNo:'',
					expectTime: '',
					remarks: '',
					procureGoodsList: [],
				},
				sumData: [{
					goodsType: 0,
					goods: []
				}, {
					goodsType: 1,
					goods: []
				},
				{
					goodsType: 7,
					goods: []
				}],
				showType: {
					showType0: true,
					showType1: true,
					showType7: true
				}

			}
		},
		computed: {
			goodsToatalCount() {
				var goodsToatal = 0;
				this.editparams.procureGoodsList.forEach(item => {
					goodsToatal += item.count;

				})
				return goodsToatal
			}
		},
		methods: {
			addGoods() {
				this.dialogState = true;
			},
			selectGoods(data) {
				//先判断有没有重复数据
				let isRepeat
				this.editparams.procureGoodsList.forEach((item) => {
					console.log('添加商品每一项',item,data);
					var tip;
					if (data.goodsType==0&&item.goodsId == data.goodsItem.goodsId&&(item.skuId==data.skuItem._id||item.skuValue==data.skuItem.sku_value)) {
							tip ='商品'
							this.$message({
							message: '该' + tip + '已重复添加',
							type: 'warning'
						})
						isRepeat = true;
						return;
						}else if(data.goodsType==1&&item.goodsId == data.goodsItem.medical_id){
					
							tip ='药品'
							this.$message({
							message: '该' + tip + '已重复添加',
							type: 'warning'
						})
						isRepeat = true;
						return;
						}else if (data.goodsType==7&&item.goodsId == data.goodsItem.consumablematerial_id) {
								tip ='耗材'
								this.$message({
							message: '该' + tip + '已重复添加',
							type: 'warning'
						})
						isRepeat = true;
						return;
						}
						
				})
				//如果不重复
				if (!isRepeat) {
					//添加商品到提交的数据中
					console.log(data.goodsItem,data.wayItem,data.skuItem,'添加');
					this.editparams.procureGoodsList.push({
						goodsId: data.goodsType==0?data.goodsItem.goodsId:(data.goodsType==1)?data.goodsItem.medical_id:data.goodsItem.consumablematerial_id,
						count: 1,
						title: data.goodsItem.title,
						brand: data.goodsType==7?'':data.goodsItem.brand_name,
						skuId: data.goodsType==0?data.skuItem._id:'',
						skuValue:  data.goodsType==0?data.skuItem.skus_name:(data.goodsType==1)?data.goodsItem.old_packinfo_info.sku_value:'',
						barCode:data.skuItem.barcode,
						goodsType: data.goodsType,
						times:data.goodsType==0?1:(data.goodsType==1)?data.goodsItem.medical_ext_info.use_times:data.goodsItem.use_times,
						unit:data.goodsType==0?data.wayItem.packing_way_name:(data.goodsType==1)?data.wayItem:data.goodsItem.packing_unit,
						unitId:data.goodsType==0?data.wayItem.packing_way_id:(data.goodsType==1)?data.wayItem:data.goodsItem.packing_unit,
						procureGoodsRemark: '',
					})
					this.$message({
						message: '添加成功',
						type: 'success'
					})
					//将提交的数据根绝商品药品分类整合，输出
					this.sumData = this.sumGoods(this.editparams.procureGoodsList);
				}

			},
			//处理成前端可展示的数据
			sumGoods(arry) {
				let sumData = [];
				arry.forEach(item => {
					let index = sumData.findIndex((ele) => {
						return item.goodsType == ele.goodsType
					})
					if (index == -1) {
						sumData.push({
							goodsType: item.goodsType,
							goods: [item],
						})
					} else {
						sumData[index].goods.push(item);
					}
				})
				return sumData
			},
			deletGoods(row, index) {
				this.$confirm('确定删除此商品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(index)
					let findindex = this.editparams.procureGoodsList.findIndex(item=>{
						return item.goodsId==row.goodsId
					})
					this.editparams.procureGoodsList.splice(findindex, 1);
					this.sumData = this.sumGoods(this.editparams.procureGoodsList);

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//展示 隐藏
			handleShopClick(type) {
				this.showType['showType' + type] = !this.showType['showType' + type]
			},
			//提交编辑的页面
			submit(isSub) {
				this.editparams.procureRequestNo=this.$route.query.procureRequestNo?this.$route.query.procureRequestNo:'';
				this.editparams.isSub = isSub;
				if (!this.expectTime || this.editparams.procureGoodsList.length == 0) {
					this.$message({
						message: '请输入期望到货日期或至少添加一个商品',
						type: 'warning'
					})
				} else {
					this.$alert(isSub == true ? '确认提交审批此申请' : '确认仅保存此申请' + '?', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							if (action == 'confirm') {
								this.editparams.expectTime = this.expectTime
								setProcureRequest(this.editparams).then(res => {
									if (res.code == 0) {
										this.$message({
											message: '申请成功',
											type: 'success'
										})
										this.$router.push({
											path: '/caigouMendianNew/shopPurchase'
										})
									}
								})
							} else {
								this.$message({
									type: 'info',
									message: '已取消'
								});
							}

						}
					});


				}

			},

			procureRequestDl(procureRequestNo) {
				procureRequestDl({
					procureRequestNo
				}).then(res => {
					if (res.code == 0) {
						this.expectTime = res.data.expectTime;
						this.editparams.procureRequestNo = res.data.procureRequestNo;
						this.editparams.procureGoodsList = res.data.procureGoodsList;
						this.editparams.expectTime = res.data.expectTime;
						this.editparams.remarks = res.data.remarks;
						this.sumData = this.sumGoods(this.editparams.procureGoodsList);
					}
				})
			},
			isBack() {
				this.$alert('你正在申请采购,返回数据将不会保存,确认返回', '确认返回', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == 'confirm') {
							this.$router.back();
						} else {
							this.$message({
								type: 'info',
								message: '取消返回'
							});
						}
					}
				});
			},

		},
		created() {
			if (this.$route.query.procureRequestNo) {
				console.log(this.$route.query.procureRequestNo,"procureRequestNo");
				this.procureRequestDl(this.$route.query.procureRequestNo);
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.page {
		.goodscon {
			padding: 0 20px;
			padding-bottom: 50px;
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.footer {
			background-color: #f5f5f5;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;

			.desc {
				margin-right: 20px;
			}
		}
	}
</style>
